import { useAppState } from '../useAppState';

export const useBookingPlacesEditorState = () => {
  const { bookingPlacesEditorState } = useAppState();

  return bookingPlacesEditorState;
};
